import { useState, useEffect } from 'react';
import { ITicker } from '@kattana-io/common';
import { KattanaAPI } from '../../store/createStore';

// TODO: cancel token

const useGetWatchlistItems = (ids: string) => {

  const [state, setState] = useState<{is_loading: boolean, items: ITicker[], is_error: boolean}>({
    is_loading: true,
    items: [],
    is_error: false
  });

  useEffect(() => {
    setState({
      ...state,
      is_loading: true,
      is_error: false,
    });
    if (ids) {
      const controller = new AbortController();

      KattanaAPI.tickersByIds(ids, { signal: controller.signal }).then((data: any) => {
        setState({
          items: data,
          is_error: false,
          is_loading: false
        });
      }).catch(() => {
        setState({
          items: [],
          is_error: true,
          is_loading: false
        });
      });

      return () => {
        controller.abort();
      };
    } else {
      setState({
        items: [],
        is_loading: false,
        is_error: false
      });
    }
  }, [ids]);

  return {
    items: state.items,
    is_loading: state.is_loading,
    is_error: state.is_error,
  };
};

export default useGetWatchlistItems;
